import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngxs/store";

export const firstTimeLoginGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const userState = store.selectSnapshot<any>((state) => state.UserState);

  if (
    userState?.isUpdatePassword &&
    userState?.user?.userId &&
    userState?.tempUserId &&
    userState?.tempPass
  ) {
    return true;
  }

  if (userState?.isPasswordExpired && userState?.user?.userId) {
    return router.createUrlTree(["/password-expired"]);
  }

  return router.createUrlTree(["/login"]);
};
